import React, { useRef, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import GameBoard from "../Board/GameBoard";
import _ from "lodash";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import DefaultDice from "./../../assets/images/board/dice/DadosyMano_314px.png";
import Dice from "../Dice/Index";
import ApiCommonContent from "../../services/GenericContent";
import "./styles.scss";
import { ButtonTypes, CommonContent, ContentKey } from "../../types/Types";
import { GameDetails, GameMode, UserAccount } from "../../types/Game";
import CountdownTimer from "../CountDownTime";
import PlayerService from "../../services/PlayerService";
import IconButton from "@mui/material/IconButton";
import { useGlobalAudioPlayer } from "react-use-audio-player";
import RollDiceSound from "./../../assets/sounds/071950_dice-rolling-88974.mp3";
import { motion } from "framer-motion";

export type Props = {
  diceNumber: number;
  timeSpining: number;
  onDiceStop: (diceNumbers: number[]) => void;
  onTimeOut: () => void;
  open: boolean;
  content: CommonContent[];
  user: UserAccount;
  game: GameDetails;
}; 


const DiceModal = (props: Props) => {
  const { load } = useGlobalAudioPlayer();
  const [throwDice, setThrowDice] = React.useState(false);
  const [diceDone, setDiceDone] = React.useState(false);
  const [showDefault, setShowDefault] = React.useState(true);
  const [diceSideNumbers, setDiceSideNumbers] = React.useState<Array<number>>(
    []
  );
  const [showDiceResult, setShowDiceResult] = React.useState<boolean>(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

  useEffect(() => {
    if (showDiceResult) {
      console.log("Dice are closed");
      props.onDiceStop(diceSideNumbers);
    }
  }, [showDiceResult]);

  useEffect(() => {
    if (PlayerService.getTotal(props.game.diceResult) <= 0) {
      setDiceDone(false);
      setDiceSideNumbers([]);
      setShowDefault(true);
    }
  }, [props.game]);

  const throwTheDice = () => {
    load(RollDiceSound, {
      autoplay: true,
    });
    const dicesSides = GameBoard.getDiceSideNumbers(props.diceNumber);
    console.log("Dice numbers:", dicesSides);
    setDiceDone(true);
    setDiceSideNumbers(dicesSides);
    setThrowDice(true);
    setShowDefault(false);
    setShowDiceResult(false);
    setTimeout(() => {
      setThrowDice(false);
      setShowDiceResult(true);
      setDiceDone(false);
    }, 4000);
  };

  return (
    <Box>
      <Dialog
        className="diceContainer"
        fullScreen={fullScreen}
        open={props.open}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" className="backgroundAzul">
          {props.user.name}
          {"! "}
          {ApiCommonContent.getKeyValue(
            props.content,
            ContentKey.YOUR_TURN_TO_PLAY
          )}
        </DialogTitle>
        <DialogContent className="diceModalContent">
          {showDefault === false && (
            <Dice
              throwDice={throwDice}
              diceSideNumbers={diceSideNumbers}
              showDiceResult={showDiceResult}
              numberOfDices={props.diceNumber}
            />
          )}
          {showDefault && (
            <motion.div
              animate={{ scale: 1.1 }}
              transition={{ repeat: Infinity, duration: 2 }}
            >
              <IconButton onClick={throwTheDice}>
                {" "}
                <img className="static-dice" src={DefaultDice} />
              </IconButton>
            </motion.div>
          )}
          {props.game.mode === GameMode.PlayWithFriends && (
            <CountdownTimer
              stop={showDefault === false}
              time={0.5}
              onTimeOut={props.onTimeOut}
            />
          )}
        </DialogContent>
        <DialogActions className="backgroundAzul">
          {PlayerService.getTotal(props.game.diceResult) <= 0 && !diceDone && (
            <Button onClick={throwTheDice}>
              {ApiCommonContent.getButtonName(
                props.content,
                ButtonTypes.THROW_THE_DICE
              )}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DiceModal;
